import One from "./pictures/ro1.jpeg";
import Two from "./pictures/ro2.jpeg";
import Three from "./pictures/ro3.jpeg";
import Four from "./pictures/ro4.jpeg";
import Five from "./pictures/ro5.jpeg";
import Six from "./pictures/ro6.jpeg";
import Seven from "./pictures/ro7.jpeg";
import Eight from "./pictures/ro8.jpeg";
import Nine from "./pictures/ro9.jpeg";
import Ten from "./pictures/ro10.jpeg";
import Eleven from "./pictures/ro11.jpeg";
import Twelve from "./pictures/ro12.jpeg";


function Gallery() {
    const images = [One, Two, Three, Four, Five, Six,
        Seven, Eight, Nine, Ten, Eleven, Twelve
    ];

    return (
        <div className="gallery-div">
            <h2 className="gallery-h2">Gallery:</h2>
            <ul className="gallery-ul">
                {images.map((image) => {
                    return <img src={image} alt={"xd"} />
                })}
            </ul>
        </div>
    )
}

export default Gallery;